<template>
  <!-- 在<footer>上加入 .page-footer 增添頁腳樣式 -->
  <footer class="page-footer blue-grey lighten-3 shadow">
    <div class="container">
      <div class="row">
        <div class="col s12">
          <div id="footer-logo">
            <img src="./../assets/img/logo1.png" alt="Logo of Dan" />
          </div>
          <p class="white-text text-darken-3">Learn more about Dan</p>
          <div id="footer-links">
            <a
              href="https://github.com/iita71737?tab=repositories"
              target="_blank"
              class="black-text text-lighten-3"
              ><i class="fab fa-github fa-2x"></i
            ></a>
            <a
              href="https://medium.com/@iita71737"
              target="_blank"
              class="black-text text-lighten-3"
              ><i class="fab fa-medium fa-2x"></i
            ></a>
            <a
              href="https://www.linkedin.com/in/chih-hao-lin-504b2ab4/
"
              target="_blank"
              class="light-blue-text text-darken-3"
              ><i class="fab fa-linkedin fa-2x"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright center">
      <div class="container">
        Dan's Portfolio © 2021 Copyright
      </div>
    </div>
  </footer>
</template>
